import { createAsyncThunk } from "@reduxjs/toolkit";
import { ChatNetworkService } from "./ChatNetworkService";
import { queryClient } from "../../../../Utils/tanstack-query";
import { setCachedSessionsData } from "./chat.slice";

export class LiveChatActions {
  //* GET ALL TEMPLATES LIST
  static getChannelsListings = createAsyncThunk(
    "LiveChatSlice/getChannelsListings",
    (data: any, { dispatch, rejectWithValue }: any) => {
      return ChatNetworkService.getChannelsListings(data)
        .then((response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    }
  );
  //* GET ALL LABLES LIST
  static getLabelsListings = createAsyncThunk(
    "LiveChatSlice/getLabelsListings",
    (data: any, { dispatch, rejectWithValue }: any) => {
      return ChatNetworkService.getLabelsListings(data)
        .then((response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    }
  );
  //* GET ALL LABLES LIST
  static getAgentsListings = createAsyncThunk(
    "LiveChatSlice/getAgentsListings",
    (data: any, { dispatch, rejectWithValue }: any) => {
      return ChatNetworkService.getAgentsListings(data)
        .then((response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    }
  );

  //* GET ALL SESSIONS LIST
  // static getSessionsListings = createAsyncThunk(
  //   "LiveChatSlice/getSessionsListings",
  //   (data: any, { dispatch, rejectWithValue }: any) => {
  //     return ChatNetworkService.getSessionsListings(data)
  //       .then((response: any) => {
  //         return response;
  //       })
  //       .catch((error: { response: unknown }) => {
  //         return rejectWithValue(error?.response);
  //       })
  //       .finally(() => { });
  //   }
  // );

  static getSessionsListings = createAsyncThunk(
    "LiveChatSlice/getSessionsListings",
    async (payload: any, { dispatch, rejectWithValue }: any) => {
      const { offset, limit, data } = payload;
      const keyIdentifiers = {
        ...data,
        limit: limit,
        offset: offset,
      };
      const queryKey = ["conversations", "sessions", "listing", keyIdentifiers];

      // 1) if we have cache, prime Redux immediately (no loader)
      const cached = queryClient.getQueryData(queryKey);
      if (cached) {
        dispatch(setCachedSessionsData(cached));
      }

      // 2) then fetch fresh & let RTK set loading/fulfilled as usual
      return ChatNetworkService.getSessionsListings(payload)
        .then((response: any) => {
          queryClient.setQueryData(queryKey, response);
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        });
    }
  );

  //* GET ALL SESSIONS LIST
  static appendSessionsListings = createAsyncThunk(
    "LiveChatSlice/appendSessionsListings",
    (data: any, { dispatch, rejectWithValue }: any) => {
      return ChatNetworkService.getSessionsListings(data)
        .then((response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    }
  );
  // Search canned messages
  static getChatCannedResponses = createAsyncThunk(
    "LiveChatSlice/getChatCannedResponses",
    (data: any, { dispatch, rejectWithValue }: any) => {
      return ChatNetworkService.getChatCannedResponses(data)
        .then((response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        });
    }
  );
}
